<div class="main">
  <div class="loading-shade" *ngIf="loading">
    <mat-spinner *ngIf="loading"></mat-spinner>
  </div>
  <mat-card>
    <img [src]="img" alt="Autof" />
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <mat-form-field appearance="standard">
        <mat-label>Телефон</mat-label>
        <input matInput type="text" mask="(000) 000 00 00" formControlName="phone" />
        <mat-icon matSuffix>phone</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="standard">
        <mat-label>Пароль</mat-label>
        <input matInput type="password" formControlName="password" />
        <mat-icon matSuffix>password</mat-icon>
      </mat-form-field>
      <button type="submit" color="primary" mat-raised-button>Войти</button>
    </form>
  </mat-card>
</div>
